module.exports = __webpack_public_path__ + "img/02_sp.cf9c98bf.jpg";